import Vue from "vue";

const namespaced = true;

function initialState() {
	return {
		levels: {},
		currentLevel: null
	};
}

const state = {
	levels: initialState().levels,
	currentLevel: initialState().currentLevel
};

const mutations = {
	SET_LEVEL: (state, level) => {
		Vue.set(state.levels, level.id, level);
	},
	SET_CURRENT_LEVEL: (state, level) => {
		Vue.set(state, "currentLevel", level);
	},
	SET_CURRENT_LAYOUT: (state, layout) => {
		Vue.set(state.currentLevel, "layout", layout);
	},
	UPDATE_SCHEMA_PROPERTY: (state, { boothId, id, value }) => {
		if (!state.currentLevel.schema.data[boothId]) {
			Vue.set(state.currentLevel.schema.data, boothId, {});
		}
		Vue.set(state.currentLevel.schema.data[boothId], id, value);
	}
};

const actions = {
	create: ({ commit }, level) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/admin/level`, {
					level: level
				})
				.then(response => {
					commit("SET_LEVEL", response.data.level);
					resolve();
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	},
	createWithPlan: ({ commit }, data) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/admin/level/withPlan`, {
					levels: data.levels,
					event: data.event
				})
				.then(response => {
					commit("SET_LEVEL", response.data.level);
					resolve();
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	},
	fetchSingle: ({ commit }, { id }) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.get(`/level/${id}`)
				.then(response => {
					commit("SET_LEVEL", response.data.level);
					resolve(response.data.level);
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	},
	fetchAll: ({ commit }) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.get(`/level`)
				.then(response => {
					for (const level of response.data.levels) {
						commit("SET_LEVEL", level);
					}
					resolve();
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	},
	update: ({ commit }, level) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/admin/level/${level.id}`, {
					level: level
				})
				.then(response => {
					commit("SET_LEVEL", response.data.level);
					resolve(response.data.level);
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	}
};

const getters = {
	all: (state, getters, rootState) => {
		if (rootState.isLoading) return {};
		return state.levels;
	},
	asArray: (state, getters, rootState) => {
		if (rootState.isLoading) return [];
		return Object.values(state.levels);
	}
};

export default {
	namespaced,
	state,
	mutations,
	actions,
	getters
};
